module.exports = ".helper-flow {\n  height: 0px;\n  opacity: 0; }\n  .helper-flow.active {\n    height: auto;\n    opacity: 1;\n    -webkit-transition: all ease 0.5s;\n    transition: all ease 0.5s; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/elements-helper/elements-helper.component.scss
// module id = ./src/app/shared/elements-helper/elements-helper.component.scss
// module chunks = main